import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { Space } from 'antd';
import { formatNumber } from 'utils/numberFormat';
import Currency from 'components/Currency';

export interface PackageTimePanelProps {
  orderType: Pay.OrderType;
  curWorkingPackage: Pay.OrderedPackage;
  data: Pay.CalculatePackagePriceRst;
  currency: General.Currency;
  checkedPackageId?: Pay.PackageId;
  durationNum: Pay.DurationNum;
}

// 升级/续订套餐的信息
export const PackageTimePanel = (props: PackageTimePanelProps) => {
  const { orderType, curWorkingPackage, data, currency, checkedPackageId, durationNum } = props;

  const {
    beforeValidStart,
    beforeValidEnd,
    upgradePrice,
    increaseDurationPrice,
    afterValidStart,
    afterValidEnd,
  } = data;

  const { t } = useTranslate();

  return (
    <Container direction="vertical" size={4}>
      <div>
        <Label>
          {orderType === 'UPGRADE' ? t('market.升级前') : t('market.续订前')}(
          {t(`套餐.${curWorkingPackage.id}`)}){t('market.有效期')}
        </Label>
        <span>
          {beforeValidStart}-{beforeValidEnd}
        </span>
      </div>

      {checkedPackageId ? (
        <div>
          <Label>
            {orderType === 'UPGRADE' ? t('market.升级后') : t('market.续订后')}(
            {t(`套餐.${checkedPackageId}`)}){t('market.有效期')}
          </Label>
          <span>
            {afterValidStart}-{afterValidEnd}
            {orderType === 'UPGRADE' && beforeValidEnd !== afterValidEnd ? (
              <UpgradeAddTimeTip>
                {t('market.时长增加多少', { s: t(`套餐时长.${durationNum}`) })}
              </UpgradeAddTimeTip>
            ) : null}
          </span>
        </div>
      ) : null}

      {orderType === 'UPGRADE' ? (
        <>
          <div>
            <Label>{t('market.升级套餐')}</Label>
            <span>
              {formatNumber(upgradePrice, '0,0.00')}
              <Currency value={currency} />
            </span>
          </div>
          <div>
            <Label>{t('market.增加时长')}</Label>
            <span>
              {formatNumber(increaseDurationPrice, '0,0.00')}
              <Currency value={currency} />
            </span>
          </div>
        </>
      ) : null}
    </Container>
  );
};

const Container = styled(Space)`
  color: var(--fett-text-tertiary);
`;

const Label = styled.span`
  &:after {
    content: ':';
    margin-right: 4px;
  }
`;

const UpgradeAddTimeTip = styled.span`
  margin-left: 8px;
  font-size: 12px;
  color: var(--fett-scenario-accent-text);
  background: #d7e1fa;
  padding: 0 4px;
  border-radius: 2px;
`;
